import * as React from 'react';
import { Typography } from '@mui/material';

import { NotificationsForm } from 'forms';
import { useAppDispatch } from 'store/store.hook';
import { updateLayout } from 'store/slices/layout.slice';

export const ProfileNotificationsPage = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(
      updateLayout({
        headerTitle: 'Notifications',
      }),
    );
  }, []);

  return (
    <>
      <Typography variant="h5">Notifications</Typography>

      <NotificationsForm />
    </>
  );
};
